var map = {
	"./chlg-logo-default.png": "d60c",
	"./currie-cup-logo-default.png": "4582",
	"./epl-logo-default.png": "cb33",
	"./euro-logo-default.png": "0d82",
	"./natl-logo-default.png": "08d6",
	"./rwc-logo-default.png": "d0d0",
	"./wwc-logo-default.png": "0a71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "899e";